import { Microfrontend } from '@thoughtspot/microfrontends';
import React from 'react';
import { loadMicroFrontendComponent } from './microfrontend-wrapper';
import { initMicroFrontend } from './microfrontends.util';

enum EurekaComponents {
    EurekaPage = 'EurekaPage',
    EurekaMainSearchBar = 'EurekaMainSearchBar',
    CreateAiAnswerSearchBar = 'CreateAiAnswerSearchBar',
    DataPanelTopLiveboards = 'DataPanelTopLiveboards',
    DataPanelTopAnswers = 'DataPanelTopAnswers',
    DataStatsContainer = 'DataStatsContainer',
}

export const EurekaPage = loadMicroFrontendComponent(
    Microfrontend.EUREKA,
    EurekaComponents.EurekaPage,
);
export const EurekaMainSearchBar = loadMicroFrontendComponent(
    Microfrontend.EUREKA,
    EurekaComponents.EurekaMainSearchBar,
);

export const DataPanelTopAnswers = loadMicroFrontendComponent(
    Microfrontend.EUREKA,
    EurekaComponents.DataPanelTopAnswers,
);

export const DataPanelTopLiveboards = loadMicroFrontendComponent(
    Microfrontend.EUREKA,
    EurekaComponents.DataPanelTopLiveboards,
);

export const EurekaNlpFeedbackContainer = (props: any): React.ReactElement => (
    <></>
);

export const NLInterpretationsContainer = (props: any): React.ReactElement => (
    <></>
);

export const NlsFeedbackLeaderboardContainer = (
    props: any,
): React.ReactElement => <></>;

export const NlsFeedbackContainer = (props: any): React.ReactElement => <></>;

export const NlsFeedbackConfirmationModalContainer = (
    props: any,
): React.ReactElement => <></>;

export const EurekaAiAnswerTitleDescriptionContainer = (
    props: any,
): React.ReactElement => <></>;

export const CreateAiAnswerPage = (props: any): React.ReactElement => <></>;

export const CreateAiAnswerSearchBar = loadMicroFrontendComponent(
    Microfrontend.EUREKA,
    EurekaComponents.CreateAiAnswerSearchBar,
);

export const NlsAnswerSageTokenContainer = (props: any): React.ReactElement => (
    <></>
);

export const NlsFewshotExampleContainer = (props: any): React.ReactElement => (
    <></>
);

export const UnifiedCreateAiAnswerPage = (props: any): React.ReactElement => (
    <></>
);

export const UnifiedCreateAiAnswerSearchBar = (
    props: any,
): React.ReactElement => <></>;

export const DataStatsContainer = loadMicroFrontendComponent(
    Microfrontend.EUREKA,
    EurekaComponents.DataStatsContainer,
);

initMicroFrontend(Microfrontend.EUREKA);
